export default "__VITE_ASSET__B61kCaA___"